module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/apercu-medium-pro-c78361955fadf5c51cea54ce1b78d8d3.ttf";